function NXTotalSales() {
  return (
    <svg
      width="60"
      height="53"
      viewBox="0 0 60 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="40" cy="20" r="20" fill="#E7F7EF" />
      <circle cx="17" cy="3" r="3" fill="#E7F7EF" />
      <path
        d="M14.4531 36.8831C14.4531 39.0331 16.1031 40.7664 18.1531 40.7664H22.3365C24.1198 40.7664 25.5698 39.2497 25.5698 37.3831C25.5698 35.3497 24.6865 34.6331 23.3698 34.1664L16.6531 31.8331C15.3365 31.3664 14.4531 30.6497 14.4531 28.6164C14.4531 26.7497 15.9031 25.2331 17.6865 25.2331H21.8698C23.9198 25.2331 25.5698 26.9664 25.5698 29.1164"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 23V43"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 49.6667C29.2047 49.6667 36.6667 42.2048 36.6667 33C36.6667 23.7953 29.2047 16.3333 20 16.3333C10.7952 16.3333 3.33333 23.7953 3.33333 33C3.33333 42.2048 10.7952 49.6667 20 49.6667Z"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXTotalSales;
